var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { CREATE_EXPERIENCE } from "@ane/antlr/lib/MDLMetrics/models/MetricDefinitionUIModel";
import { METRIC_AUTHORING_MODE, colorSchemeToMetricDirection, DEFAULT_METADATA } from "../CreateModal/CreateModal.constants.js";
import { parseMetricField } from "../CreateModal/CreateModal.utils.js";
import { mdlMetricDefinitionGenerator } from "@ane/antlr/lib/MDLMetrics/utils/MdlMetricDefinitionGenerator";
import { MAUIMODES } from "../../../../common/models/MAUI.models.js";
import { QuickCompilationStatuses } from "./QuickValidate.constants.js";
const METRIC_DEFINITION_COLORS = {
  0: "#18BFCA",
  1: "#5B5FC7",
  aggregation: "#E43BA6"
};
const getMetricDefinitionColor = (index) => {
  let color = void 0;
  switch (index) {
    case 0:
      color = METRIC_DEFINITION_COLORS[0];
      break;
    case 1:
      color = METRIC_DEFINITION_COLORS[1];
      break;
    default:
      color = void 0;
      break;
  }
  return color;
};
const isValidMetadata = (metadata) => {
  if (!metadata) {
    return false;
  }
  if (metadata.mode === METRIC_AUTHORING_MODE.template) {
    return !!metadata.metricTemplate;
  }
  return !!metadata && !!metadata.name && !!metadata.internalName && !!metadata.description && !!metadata.level && !!metadata.desiredDirection;
};
const getMetadataFromMetricDetailsWithFilePath = (metricWithFilePath) => {
  var _a, _b;
  const metric = metricWithFilePath == null ? void 0 : metricWithFilePath.i;
  return {
    name: (metric == null ? void 0 : metric["foray:DisplayName"])["#text"] || (metric == null ? void 0 : metric["foray:DisplayName"]),
    internalName: (metric == null ? void 0 : metric["@Name"]) || "",
    level: parseMetricField(metric == null ? void 0 : metric["@Levels"])[0],
    mode: METRIC_AUTHORING_MODE.custom,
    description: ((_a = metric == null ? void 0 : metric["foray:Description"]) == null ? void 0 : _a["#cdata-section"]) || "",
    categories: parseMetricField(metric == null ? void 0 : metric["@MetricCategories"]),
    desiredDirection: (_b = colorSchemeToMetricDirection[`${metric == null ? void 0 : metric["@ColorScheme"]}`]) != null ? _b : colorSchemeToMetricDirection["Default"],
    computationFilePath: (metricWithFilePath == null ? void 0 : metricWithFilePath.filePath) || DEFAULT_METADATA.computationFilePath,
    metricTemplate: "",
    instanceIdToBeEdited: ""
  };
};
const convertDefinitionToMdl = (values) => {
  const createExperience = values.metadata.mode === METRIC_AUTHORING_MODE.custom ? CREATE_EXPERIENCE.metricWizard : CREATE_EXPERIENCE.rawMode;
  const definition = values.metadata.mode === METRIC_AUTHORING_MODE.custom ? { metricDefinition: values.metricDefinition, aggregation: values.aggregation } : { definition: "" };
  const metricMetaData = __spreadProps(__spreadValues({}, values.metadata), {
    level: values.metadata.level,
    createExperience,
    fullMetricDefinition: definition
  });
  return mdlMetricDefinitionGenerator(metricMetaData);
};
const getDescriptionComputationTemplate = (computationTemplates, templateName) => {
  var _a;
  var computationTemplate = computationTemplates == null ? void 0 : computationTemplates.find(
    (item) => item.i["@TemplateName"] === templateName
  );
  return ((_a = computationTemplate == null ? void 0 : computationTemplate.i.TemplateDescription) == null ? void 0 : _a["#cdata-section"]) || "";
};
const templateParameterMap = (computationTemplate, parameterValues) => {
  var _a;
  return (_a = computationTemplate == null ? void 0 : computationTemplate.i.TemplateParameters.TemplateParameter) == null ? void 0 : _a.reduce(
    (acc, param, index) => {
      var _a2;
      acc[param["@Name"]] = (_a2 = parameterValues[index]) == null ? void 0 : _a2.value;
      return acc;
    },
    {}
  );
};
const replaceParameterValues = (str, lookupMap) => {
  const value = str.replace(/^[\n\s]+|[\n\s]+$/g, "").replace(/,\s*/, ", ");
  return value.replace(/\$\{([^}]+)\}/g, (_, item) => lookupMap[item] ? lookupMap[item] : `\${${item}}`);
};
const getMetricsFromComputationTemplate = (computationTemplate, parameterValues) => {
  var _a;
  const lookup = templateParameterMap(computationTemplate, parameterValues) || {};
  return ((_a = computationTemplate == null ? void 0 : computationTemplate.i.TemplateDefinition.i) == null ? void 0 : _a.filter((item) => item["@c"] === "{extension://MDLConverters/ForayConverter}Statistic").map((item) => {
    var _a2, _b, _c;
    return {
      name: replaceParameterValues(
        ((_a2 = item["foray:DisplayName"]) == null ? void 0 : _a2["#text"]) || item["foray:DisplayName"] || "",
        lookup
      ),
      level: replaceParameterValues(item["@Levels"], lookup),
      internalName: replaceParameterValues(item["@Name"], lookup),
      definition: replaceParameterValues(((_b = item["foray:Definition"]) == null ? void 0 : _b["#cdata-section"]) || "", lookup),
      description: replaceParameterValues(((_c = item["foray:Description"]) == null ? void 0 : _c["#cdata-section"]) || "", lookup),
      colorScheme: replaceParameterValues(item["@ColorScheme"] || "", lookup)
    };
  })) || [];
};
const getColumnsFromComputationTemplate = (computationTemplate, parameterValues) => {
  var _a;
  const lookup = templateParameterMap(computationTemplate, parameterValues) || {};
  return ((_a = computationTemplate == null ? void 0 : computationTemplate.i.TemplateDefinition.i) == null ? void 0 : _a.filter((item) => item["@c"] === "Column").map((item) => {
    var _a2, _b, _c;
    return {
      level: replaceParameterValues(item["@Level"] || "", lookup),
      name: replaceParameterValues(item["@Name"] || "", lookup),
      definition: ((_a2 = item.Definition) == null ? void 0 : _a2["#cdata-section"]) ? replaceParameterValues(((_b = item.Definition) == null ? void 0 : _b["#cdata-section"]) || "", lookup) : replaceParameterValues(((_c = item.Definition) == null ? void 0 : _c["#text"]) || "", lookup)
    };
  })) || [];
};
const getQuickValidateRequest = (mode, preview, metrics, columns, values) => {
  const category = mode === MAUIMODES.edit ? 3 : 2;
  if (values.metadata.mode === METRIC_AUTHORING_MODE.template) {
    return {
      metricObjects: metrics.map((metric) => ({
        name: metric.internalName || metric.name,
        level: metric.level,
        definition: metric.definition,
        category
      })),
      columnObjects: columns.map((column) => ({
        name: column.name,
        level: column.level,
        definition: column.definition,
        category
      }))
    };
  } else {
    return {
      metricObjects: [
        {
          name: values.metadata.internalName,
          level: values.metadata.level,
          definition: values.metadata.mode === METRIC_AUTHORING_MODE.code ? values.rawModeMdl : preview,
          category
        }
      ],
      columnObjects: []
    };
  }
};
const getQuickValidationNames = (metrics, columns, values) => {
  if (values.metadata.mode === METRIC_AUTHORING_MODE.template) {
    return metrics.map((metric) => metric.internalName)[0] || "";
  } else {
    return values.metadata.internalName;
  }
};
const transformQuickCompileResult = (metricsObject, quickCompileAPIResult) => {
  return metricsObject.map((metricColumn) => ({
    name: metricColumn.name,
    status: !!quickCompileAPIResult[metricColumn.name] ? QuickCompilationStatuses.Failed : QuickCompilationStatuses.Succeeded,
    errorMessage: !!quickCompileAPIResult[metricColumn.name] ? quickCompileAPIResult[metricColumn.name] : ""
  }));
};
const isQuickCompilationSuccessful = (quickCompileResult) => {
  return quickCompileResult.every((item) => item.status === QuickCompilationStatuses.Succeeded);
};
const getPrimaryDataSourceFromMdl = (dataSourceMDL) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const namespaces = dataSourceMDL.Mdl.Namespaces.Namespace;
  var dataSourceList;
  if (Array.isArray(namespaces)) {
    dataSourceList = (_d = (_c = (_b = (_a = namespaces[0]) == null ? void 0 : _a.Tables) == null ? void 0 : _b.Table) == null ? void 0 : _c.DataSources) == null ? void 0 : _d.DataSource;
  } else {
    dataSourceList = (_g = (_f = (_e = namespaces == null ? void 0 : namespaces.Tables) == null ? void 0 : _e.Table) == null ? void 0 : _f.DataSources) == null ? void 0 : _g.DataSource;
  }
  if (!dataSourceList) {
    return "";
  } else if (Array.isArray(dataSourceList)) {
    return dataSourceList == null ? void 0 : dataSourceList.filter((dataSource) => dataSource["@Name"] !== "FlashResalt")[0].DataSourceManagement["@Name"];
  }
  return dataSourceList.DataSourceManagement["@Name"];
};
export {
  METRIC_DEFINITION_COLORS,
  convertDefinitionToMdl,
  getColumnsFromComputationTemplate,
  getDescriptionComputationTemplate,
  getMetadataFromMetricDetailsWithFilePath,
  getMetricDefinitionColor,
  getMetricsFromComputationTemplate,
  getPrimaryDataSourceFromMdl,
  getQuickValidateRequest,
  getQuickValidationNames,
  isQuickCompilationSuccessful,
  isValidMetadata,
  replaceParameterValues,
  templateParameterMap,
  transformQuickCompileResult
};
//# sourceMappingURL=MetricWizard.utils.js.map
